export default __webpack_public_path__ + "static/media/Awessome.b65265d0.webp";